<div class="list-container">
    <shared-form-question-answer-shipment-item class="list-item" [ngClass]="getClassListItem(item)"
        *ngFor="let item of questionsAnswers | sortBy:'questionOrder'; let index=index" [shipment]="shipment"
        [value]="item" [iReadonly]="iReadonly" [showDefaultCamera]="showDefaultCamera"
        (valueChanged)="onValueChanged($event, index)">
    </shared-form-question-answer-shipment-item>
    <div class="dummy-end"></div>
</div>